// Shared/core Stimulus controllers — registered on EVERY page (public marketing,
// authentication, and dashboard), via both app/javascript/application.js and
// app/javascript/dashboard.js.
//
// Split by ticket #2127 (bundle split public/dashboard): controllers used
// exclusively within the dashboard.html.erb layout (or Dashboard::-namespaced
// components) now live in ./dashboard_index.js instead, so the public bundle
// doesn't ship them. Everything registered here is either:
//   - used on public/marketing/auth pages (application.html.erb, authentication.html.erb), or
//   - used on BOTH public and dashboard pages (e.g. track, page-view, back), or
//   - unreferenced dead code kept here defensively (see ticket #2127 PR
//     description for the audit) rather than guessed into the dashboard bucket.
//
// IMPORTANT: `bin/rails stimulus:manifest:update` / `bin/rails generate stimulus`
// regenerate this file as a FLAT list of every controller in app/javascript/controllers/,
// which would silently re-merge the two bundles. After running either command,
// re-split any newly added dashboard-only controller into ./dashboard_index.js
// by hand and remove it from here.
import { application } from "./application"

import AcademySearchController from "./academy_search_controller"
application.register("academy-search", AcademySearchController)

import AgeConsentController from "./age_consent_controller"
application.register("age-consent", AgeConsentController)

import AlertConfigController from "./alert_config_controller"
application.register("alert-config", AlertConfigController)

import AndroidAppBannerController from "./android_app_banner_controller"
application.register("android-app-banner", AndroidAppBannerController)

import BackController from "./back_controller"
application.register("back", BackController)

import CalculatorController from "./calculator_controller"
application.register("calculator", CalculatorController)

// Setup (layout authentication, bundle public) et onboarding (dashboard) : registre partagé.
import CheckboxGroupGuardController from "./checkbox_group_guard_controller"
application.register("checkbox-group-guard", CheckboxGroupGuardController)

import ConfirmDeleteController from "./confirm_delete_controller"
application.register("confirm-delete", ConfirmDeleteController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CookiePreferencesController from "./cookie_preferences_controller"
application.register("cookie-preferences", CookiePreferencesController)

import DemoPhoneController from "./demo_phone_controller"
application.register("demo-phone", DemoPhoneController)

// Popover générique : barre de réglages du dashboard ET menu « Sports » de la nav
// vitrine (#2782, Marketing::SportsNavMenuComponent), donc registre partagé.
import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmailEditController from "./email_edit_controller"
application.register("email-edit", EmailEditController)

import ExplainerModalController from "./explainer_modal_controller"
application.register("explainer-modal", ExplainerModalController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import GoogleNativeSignInController from "./google_native_sign_in_controller"
application.register("google-native-sign-in", GoogleNativeSignInController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HideInIframeController from "./hide_in_iframe_controller"
application.register("hide-in-iframe", HideInIframeController)

import LazyIframeController from "./lazy_iframe_controller"
application.register("lazy-iframe", LazyIframeController)

import LocaleSwitcherController from "./locale_switcher_controller"
application.register("locale-switcher", LocaleSwitcherController)

import MarginCalculatorController from "./margin_calculator_controller"
application.register("margin-calculator", MarginCalculatorController)

import FreebetCalculatorController from "./freebet_calculator_controller"
application.register("freebet-calculator", FreebetCalculatorController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import OddsConverterController from "./odds_converter_controller"
application.register("odds-converter", OddsConverterController)

import PageViewController from "./page_view_controller"
application.register("page-view", PageViewController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PinnedBannersController from "./pinned_banners_controller"
application.register("pinned-banners", PinnedBannersController)

import ResetPasswordRequestController from "./reset_password_request_controller"
application.register("reset-password-request", ResetPasswordRequestController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import StepsController from "./steps_controller"
application.register("steps", StepsController)

import TocController from "./toc_controller"
application.register("toc", TocController)

// Utilisé sur app/views/dashboard/profile (layout dashboard) ET
// app/views/dashboard/setups/show (Dashboard::SetupsController force
// `layout "authentication"`, donc bundle public malgré le chemin de vue
// sous dashboard/) — reste ici plutôt que dans ./dashboard_index.js.
import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import LockedValueController from "./locked_value_controller"
application.register("locked-value", LockedValueController)

import TrackController from "./track_controller"
application.register("track", TrackController)

import NativeAnalyticsController from "./native_analytics_controller"
application.register("native-analytics", NativeAnalyticsController)
